// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__DFPle","item":"Switch_item__GSYc9","active":"Switch_active__ziU6G"};